// removed by extract-text-webpack-plugin
module.exports = {"summary-step":"summary-step__1h8Js","title":"title__2mztr","key":"key__2Ln1n","value":"value__9j9Vj","spacer-30":"spacer-30__vjlLN","spacer-20":"spacer-20__2MXfe","spacer-10":"spacer-10__3-GmE","topic":"topic__1ntIv","alert":"alert__2T0_Y"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleForm/styles/SummaryStep.scss
// module id = Clpk
// module chunks = 1